export const documentType = () => [
    { value: 'passport', name: 'Passport' },
    { value: 'driving_license', name: 'Driving License' },
    { value: 'national_identity_card', name: 'National Identity Card' }
]